import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LMContextService } from '@app/services';
import { SohoBlockGridComponent } from 'ids-enterprise-ng';

@Component({
  selector: 'lm-block-grid',
  templateUrl: 'lm-block-grid.component.html'
})
export class LMBlockGridComponent implements OnInit {
  public uiLoadingIndicatorTimeout = 0;

  @Input() showEmptyMessage = false;
  @Input() selectionMode: SohoListViewSelectable;
  @Input() emptyMessageOptions: SohoEmptyMessageOptions;

  @Input() display = 'inline-block';
  @Input() padding = '';

  @Output() itemSelected = new EventEmitter<LMBlockGridItemEvent>();
  @Output() itemDoubleClicked = new EventEmitter<LMBlockGridItemEvent>();

  @ViewChild('SohoBlockgrid') sohoBlockgrid: SohoBlockGridComponent;

  constructor(private lmContextService: LMContextService) {
    this.uiLoadingIndicatorTimeout = this.lmContextService.uiLoadingIndicatorTimeout;
  }

  ngOnInit() {}
}
